var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMeetWhite({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 90,
    height: 90,
    viewBox: "0 0 90 90",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-messages-white"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 90,
    height: 90
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "messages-white",
    clipPath: "url(#clip-messages-white)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "icons8-message-96",
    transform: "translate(-3.178 91.943)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_636",
    "data-name": "Path 636",
    d: "M37.5-86.6C26.3-83.8,16-75.7,11.3-66.1,9-61.4,8.6-59.2,8.6-52s.4,9.4,2.7,14.1C17.4-25.4,32.7-16,47.3-16H52v5c0,4.2.3,5,1.8,5,5,0,22-15.3,27.9-25.1,4.4-7.3,6.7-16.8,5.9-24.2C85.3-77.4,61.2-92.5,37.5-86.6ZM35.5-52c0,3.3-.2,3.5-3.5,3.5-2.9,0-3.6-.4-3.8-2.3-.6-4,.5-5.4,4-5C35.2-55.5,35.5-55.2,35.5-52Zm16,0c0,3.3-.2,3.5-3.5,3.5-2.9,0-3.6-.4-3.8-2.3-.6-4,.5-5.4,4-5C51.2-55.5,51.5-55.2,51.5-52Zm16,0c0,3.3-.2,3.5-3.5,3.5-2.9,0-3.6-.4-3.8-2.3-.6-4,.5-5.4,4-5C67.2-55.5,67.5-55.2,67.5-52Z",
    fill: "#fff"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMeetWhite);
export default __webpack_public_path__ + "static/media/meet-white.fb32496888c7a04a80fcfc8cc3c96c4e.svg";
export { ForwardRef as ReactComponent };